/* Publish by EComposer at 2025-07-31 20:42:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8vfb1xi6cq5"]=  window.__ectimmers["ecom-8vfb1xi6cq5"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8vfb1xi6cq5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vfb1xi6cq5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrfgoj23q5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrfgoj23q5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqajqzgeldv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqajqzgeldv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zwjma2m447').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zwjma2m447', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pxg1kbm75hg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pxg1kbm75hg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rit7r084egg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rit7r084egg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b5ryftxsux8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b5ryftxsux8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pk3r8yebhqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pk3r8yebhqs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6v8of13o4fp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6v8of13o4fp', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ynbktppuxl"]=  window.__ectimmers["ecom-ynbktppuxl"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=i.querySelector(".ecom-element.ecom-base-image"),s=i.closest(".core__row--columns");n&&(t(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-ynbktppuxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ynbktppuxl', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55agk0s27y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55agk0s27y', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ymo72d89avl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ymo72d89avl', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bwa6g5qvxll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bwa6g5qvxll', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ruebv7z168').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ruebv7z168', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rvbz61653j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rvbz61653j', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5b1jlmmr0zr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5b1jlmmr0zr', settings: {"link":"lightbox","lightbox":"yes"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ncmkf0a8bf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ncmkf0a8bf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2ih0wli9oh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2ih0wli9oh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9sxabd7bac5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9sxabd7bac5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 try{
 try{
 try{
 try{
 
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}